import styled from 'styled-components';

const ErrorMessage = ({ children, show }) => {
    return <Text show={show}>{children}</Text>;
};

export default ErrorMessage;

const Text = styled.div`
    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
    min-height: ${({ show }) => (show ? '20px' : '0px')};
    height: ${({ show }) => (show ? 'unset' : '0px')};
    font-size: 14px;
    color: #ed6868;
    height: unset;
    padding-left: 0.2rem;
    padding-top: 0.4rem;
`;
